import * as XLSX from "xlsx";
import {saveAs} from "file-saver";
import {candidateExportRows} from "./candidateExport";

export function downloadCandidates(candidates, label="recherche") {
 if(!candidates.length)throw new Error("Aucun candidat à exporter.");
 const sheet=XLSX.utils.json_to_sheet(candidateExportRows(candidates));
 sheet["!cols"]=[14,24,24,20,36,25,14,45,20,40,40,45,45,24].map(wch=>({wch}));
 sheet["!autofilter"]={ref:sheet["!ref"]};
 const book=XLSX.utils.book_new();
 XLSX.utils.book_append_sheet(book,sheet,"Candidats");
 const bytes=XLSX.write(book,{bookType:"xlsx",type:"array"});
 const name=label.trim().replace(/[^a-zA-Z0-9à-ÿ_-]+/g,"_").slice(0,50)||"recherche";
 saveAs(new Blob([bytes],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}),`candidats_${name}.xlsx`);
}
